import { CardTransactionTypeEnum, Expense, PriceIntervalEnum, Transaction } from "@finway-group/shared/lib/models"
import { Table } from "antd"
import { ColumnsType } from "antd/lib/table"
import moment from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"

import { setTransaction } from "Shared/store/actions/transaction/transactionActions"

import PriceLabel from "../../../../../components/priceLabel"
import TransactionStatusTag from "../../../../../components/transactionStatusTag"
import { ExpenseMatchedTransaction } from "../../../../../shared/hooks/transaction.hooks"

interface TransactionTabProps {
    expense: Expense
    transactions: Array<ExpenseMatchedTransaction>
    isTransactionTableLoading?: boolean
}

export const TransactionTabContent = ({ expense, transactions, isTransactionTableLoading }: TransactionTabProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()

    const transactionColumns: ColumnsType = [
        {
            key: "transactionData.date",
            ellipsis: true,
            sorter: true,
            align: "center",
            render: ({ transactionData }: Transaction) => <span>{moment(transactionData?.date).format("Do MMM, YYYY")}</span>,
        },
        {
            key: "transactionData.amount",
            ellipsis: true,
            align: "center",
            render: ({ transactionData }: Transaction) => (
                <PriceLabel value={transactionData?.amount} currency={transactionData?.currency || expense.currency} interval={PriceIntervalEnum.ONE_TIME} addPlusSign />
            ),
        },
        {
            key: "status",
            title: t("label:status"),
            ellipsis: true,
            render: ({ status, cardData }: Transaction) => (
                <TransactionStatusTag status={status} isReversal={cardData?.cardTransactionType === CardTransactionTypeEnum.ONLINE_REVERSE} />
            ),
        },
    ]

    return (
        <Table<ExpenseMatchedTransaction>
            showHeader={false}
            loading={isTransactionTableLoading}
            rowKey={({ _id }: any) => _id}
            dataSource={transactions}
            pagination={false}
            columns={transactionColumns}
            onRow={(transaction) => ({
                onClick: () => {
                    dispatch(setTransaction(transaction))
                    history.push(`/transactions/${transaction._id}`)
                },
            })}
        />
    )
}
